window.RS = window.RS || {};

window.RS.stickyATC = (function () {
  const THRESHOLD = 80;
  const MOBILE_BREAKPOINT = 767;
  const ACTIVE = "active";
  const STICKY = "sticky";
  const SIZE = "size";
  const COLOR = "color";
  const STICKY_EL = '[data-module="sticky-atc"]';
  const ATC_EL = 'button[type="submit"].single_add_to_cart_button';
  const SOLDOUT_EL = 'input[type="submit"].add_to_cart_button';
  const SOLDOUT_ANCHOR = "#frm_notify_ppr";
  const HEADER_EL = "#shopify-section-header_main";
  const COLOR_OP = "[data-op='color']";
  const SIZE_OP = "[data-op='size']";
  const BUTTON_OP = "[data-op='button'] button";
  const PROP_STICKY_OFFSET = "--sticky-atc-offset";
  const PROP_HEADER_OFFSET = "--header-offset";
  const E_VARIANT_CHANGE = "variant:change";
  const D_SOLDOUT = "data-soldout";
  let stickyEl, atcEl, soldoutEl, headerEl;
  let colorOp, colorOpList, sizeOp, sizeOpList, buttonOp, anchorEl;
  let soldOut = false;
  let stickyOffset = 0;
  let dataVars = {};

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function removeClass(el, className) {
    if (el && el.classList.contains(className)) {
      el.classList.remove(className);
    }
  }

  function addClass(el, className) {
    if (el && !el.classList.contains(className)) {
      el.classList.add(className);
    }
  }

  function setSticlkyOffset(offset = 0) {
    document.documentElement.style.setProperty(
      PROP_STICKY_OFFSET,
      `${offset}px`
    );
  }

  function onScroll() {
    if (soldoutEl || atcEl && stickyEl) {
      let headerOffset = 0;

      if (headerEl) {
        headerOffset = headerEl.offsetTop + headerEl.offsetHeight;
        document.documentElement.style.setProperty(
          PROP_HEADER_OFFSET,
          `${headerOffset}px`
        );
      }
      let rect;
      if (!soldOut) {
        rect = atcEl?.getBoundingClientRect();
      } else {
        rect = soldoutEl.getBoundingClientRect();
      }

      if (rect.top <= THRESHOLD) {
        if ( stickyOffset === 0) {
          stickyOffset = stickyEl?.offsetHeight || 0;
          setSticlkyOffset(stickyOffset);
        }
        addClass(stickyEl, STICKY);
      } else {
        if (stickyOffset > 0) {
          setSticlkyOffset(0);
          stickyOffset = 0;
        }
        removeClass(stickyEl, STICKY);
      }
    }
  }

  function updateButton(available) {
    if (buttonOp) {
      const soldout = buttonOp.hasAttribute(D_SOLDOUT);
      if (available) {
        if (soldout) {
          buttonOp.removeAttribute(D_SOLDOUT);
        }
        const content = buttonOp.dataset?.availableText;
        buttonOp.textContent = content;
      } else {
        if (!soldout) {
          buttonOp.setAttribute(D_SOLDOUT, "");
        }
        const content = buttonOp.dataset?.soldoutText;
        buttonOp.textContent = content;
      }
    }
  }

  function updateColor(value) {
    if (colorOp && colorOpList.length > 0) {
      colorOpList.forEach(function (li) {
        const colorValue = li.dataset?.escape;
        if (colorValue === value) {
          addClass(li, ACTIVE);
        } else {
          removeClass(li, ACTIVE);
        }
      });
    }
  }

  function updateSize(value) {
    if (sizeOp && sizeOpList.length > 0) {
      sizeOpList.forEach(function (li) {
        const sizeValue = li.dataset?.escape;
        if (sizeValue === value) {
          addClass(li, ACTIVE);
        } else {
          removeClass(li, ACTIVE);
        }
      });
    }
  }

  function onSwatchChanged(e) {
    const variant = e.detail;
    if (!variant) {
      return;
    }
    const { available } = variant;
    soldOut = !available;

    updateButton(available);

    for (const key in dataVars) {
      if (dataVars.hasOwnProperty(key)) {
        const value = dataVars[key];
        const optionName = `option${value}`;
        const optionValue = variant[optionName];
        if ( key && value ) {
          switch (key) {
            case SIZE:
              if ( optionValue) {
                updateSize(optionValue);
              }
              break;
            case COLOR:
              if ( optionValue) {
                updateColor(optionValue);
              }
              break;
            default:
              break;
          }
        }
      }
    }
  }

  function onClick(e) {
    const target = e.target;
    if (target.matches(BUTTON_OP)) {
      const soldout = target.hasAttribute(D_SOLDOUT);

      if (soldout) {
        if (anchorEl) {
          const offset =
            parseInt(
              getComputedStyle(document.documentElement).getPropertyValue(
                PROP_HEADER_OFFSET
              )
            ) || 0;
          const elementPosition = anchorEl.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      } else {
        if (atcEl) {
          atcEl.click();
        }
      }
    }
  }

  function init() {
    document.addEventListener(E_VARIANT_CHANGE, debounce(onSwatchChanged, 100));
    stickyEl = document.querySelector(STICKY_EL); // sticky atc module
    atcEl = document.querySelector(ATC_EL); // PDP add to cart button
    soldoutEl = document.querySelector(SOLDOUT_EL); // PDP sold out button
    headerEl = document.querySelector(HEADER_EL); // PDP header
    colorOp = stickyEl.querySelector(COLOR_OP); // stickyATC color option
    colorOpList = colorOp?.querySelectorAll("li");
    sizeOp = stickyEl.querySelector(SIZE_OP); // stickyATC size option
    sizeOpList = sizeOp?.querySelectorAll("li");
    buttonOp = stickyEl.querySelector(BUTTON_OP); // sticky atc button
    anchorEl = document.querySelector(SOLDOUT_ANCHOR); // PDP sold out anchor
    soldOut = stickyEl?.dataset?.available === "false";

    const { size, color } = stickyEl.dataset;
    dataVars = { size, color };

    if (stickyEl) {
      stickyOffset = stickyEl.offsetHeight;
    }
    setSticlkyOffset(stickyOffset);
    document.documentElement.style.setProperty(
      PROP_HEADER_OFFSET,
      `${THRESHOLD}px`
    );
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      window.addEventListener("scroll", debounce(onScroll, 100));
      onScroll();
      updateButton(!soldOut);
    }

    if (stickyEl) {
      stickyEl.addEventListener("click", onClick);
    }
  }

  return {
    init,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  window.RS.stickyATC.init();
});
